import { Modal } from 'components';
// eslint-disable-next-line no-unused-vars
import errorIcon from 'assets/img/error-icon.svg';
import './styles.scss';

export default function ErrorModal(props) {
  return (
    <Modal
      containerClassName="ErrorModal"
      titleContainerClassName="ErrorModal__TitleContainer"
      titleClassName="ErrorModal__Title text-center"
      subtitleClassName="ErrorModal__Subtitle text-center"
      {...props}
    />
  );
}
